<template>
    <div>
        <div class="customer-list">
            <div class="next-button">
                <el-button size="small" type="primary" icon="el-icon-plus" plain @click="clickAddAndEditShow(1)">新增</el-button>
                <el-button size="small" type="primary" @click="handleSearch">查询</el-button>
                <el-button size="small" type="success" @click="handleReset">重置</el-button>
            </div>
        </div>
        <el-table
            :stripe="true"
            :data="tableData"
            style="width: 100%"
            height="670"
            border
            v-loading="listLoading" 
            >
            <!-- eslint-disable  -->
            <el-table-column label="序列">
                <el-table-column show-overflow-tooltip width="200">
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model="form.SortNo" placeholder="输入关键字搜索"/>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.SortNo || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="证书编号" >
                <el-table-column show-overflow-tooltip>
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model="form.Id" placeholder="输入关键字搜索"/>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.Id || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="证书一级名称">
                <el-table-column show-overflow-tooltip>
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model="form.FirstLevelName" placeholder="输入关键字搜索"/>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.FirstLevelName || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="证书二级名称">
                <el-table-column show-overflow-tooltip>
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model="form.SecondLevelName" placeholder="输入关键字搜索"/>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.SecondLevelName || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="级别">
                <el-table-column show-overflow-tooltip>
                    <template slot="header" slot-scope="scope">
                        <el-select size="mini" v-model="form.Level" placeholder="请选择层级" style="width: 100%;">
                            <el-option :value="1" label="一级"></el-option>
                            <el-option :value="2" label="二级"></el-option>
                        </el-select>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.Level==1?'一级':'二级'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="是否有效">
                <el-table-column show-overflow-tooltip>
                    <template slot="header" slot-scope="scope">
                        <el-select size="mini" v-model="form.IsEffective" placeholder="请选择是否有效" style="width: 100%;">
                            <el-option :value="1" label="有效"></el-option>
                            <el-option :value="2" label="无效"></el-option>
                        </el-select>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.IsDelete?'无效':'有效'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="操作" fixed="right"  width="300">
                <template slot-scope="scope">
                    <el-button size="mini" @click="clickAddAndEditShow(2,scope.row)">编辑</el-button>
                    <el-button v-if="scope.row.IsDelete" size="mini" type="primary" @click="UpdateCertificateTypeStatusFun(scope.row)">恢复</el-button>
                    <el-button v-if="!scope.row.IsDelete" size="mini" type="warning" @click="UpdateCertificateTypeStatusFun(scope.row)">作废</el-button>
                    <el-button v-if="scope.row.IsMaxSortNo || !scope.row.IsMaxSortNo && !scope.row.IsMinSortNo" size="mini" type="info" plain @click="upDownMove(scope.row.Id, -1)">上移</el-button>
                    <el-button v-if="scope.row.IsMinSortNo || !scope.row.IsMaxSortNo && !scope.row.IsMinSortNo" size="mini" type="info" plain @click="upDownMove(scope.row.Id, 1)">下移</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div style="margin: 10px;overflow: hidden">
            <div style="float: right;" v-show="tableData.length">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="form.PageIndex"
                    :page-sizes="[10, 20, 50, 100, 200]"
                    :page-size="form.PageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total">
                </el-pagination>
            </div>
        </div>


        <el-dialog
            :visible.sync="editorShow" 
            :title="title" 
            :close-on-click-modal="false"
            width="600px" 
            ref="dialog" 
        >
            <!-- @close="editorClose" -->
            <el-form label-width="100px" ref="messageForm">
                <el-form-item label="证书名称：" required>
                    <el-input size="medium" v-model="CertificateTypeName" placeholder="请输入证书名称"></el-input>
                </el-form-item>
                
                <el-form-item label="是否一级：" required>
                    <el-radio-group v-model="IsFirstLevel">
                        <el-radio :label="true">是</el-radio>
                        <el-radio :label="false">否</el-radio>
                    </el-radio-group>
                </el-form-item>
                
                <el-form-item label="父级：" required v-show="!IsFirstLevel">
                    <el-select size="medium" v-model="ParentId" placeholder="请选择父级" style="width: 100%;">
                        <el-option :value="item.Id" :label="item.FirstLevelName" v-for="(item, index) in ParentList" :key="index"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label=" ">
                    <el-button size="medium" :loading="submitAllLoading" @click="certuficatFun">确定</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>
<script>
import {
    ListCertificateType,
    AddCertificateType,
    UpdateCertificateType,
    UpdateCertificateTypeStatus,
    UpdateCertificateTypeSortNo,
} from "@/service/certificate";
import { Tree } from 'element-ui';
    export default {
        data(){
            return {
                listLoading: false,
                form: {
                    PageIndex: 1,
                    PageSize: 10,

                    SortNo: '',             // 排序编号
                    Id: '',                 // 证书类型id
                    FirstLevelName: '',     // 一级证书名称
                    SecondLevelName: '',    // 二级证书名称
                    Level: '',              // 层级
                    IsEffective: '',        // 是否有效
                    UserType: 1,            // 用户类型 1个人 2企业
                },
                oraginForm: {},
                searchData: {},
                total: 0,                   // 总条数

                tableData: [],


                editorShow: false,
                title: '新增/编辑',
                
                CertificateTypeName: '',    // 证书名称
                IsFirstLevel: true,         // 是否一级
                ParentId: '',               // 父级id

                Id: '',

                ParentList: [],            // 父级列表
                submitAllLoading: false,
            }
        },
        created() {
            this.oraginForm = JSON.parse(JSON.stringify(this.form))
            this.tableData = [];
            this.handleSearch()
            // this.GetParentList()
        },
        methods:{
            //渲染列表
            handleSearch() {
                this.searchData = Object.assign({}, this.form)
                this.handleCurrentChange(1)
            },
            // 重置
            handleReset() {
                this.form = JSON.parse(JSON.stringify(this.oraginForm))
                this.handleSearch()
            },
            handleCurrentChange(val) {
                if (this.listLoading) return
                this.form.PageIndex = val
                this.searchData.PageIndex = val
                this.GetCertificateTypeList()
            },
            //翻页
            handleSizeChange(val) {
                if (this.listLoading) return
                this.form.PageIndex = 1
                this.form.PageSize = val
                this.searchData.PageIndex = 1
                this.searchData.PageSize = val
                this.GetCertificateTypeList()
            },
            async GetCertificateTypeList(){
                this.listLoading = true
                let data = JSON.parse(JSON.stringify(this.searchData))
                !data.SortNo && delete data.SortNo
                !data.Id && delete data.Id
                !data.FirstLevelName && delete data.FirstLevelName
                !data.SecondLevelName && delete data.SecondLevelName
                !data.Level && delete data.Level
                !data.IsEffective && delete data.IsEffective
                console.log(data)
                let res = await ListCertificateType(data)
                this.listLoading = false
                if(res.Result != 1) {
                    return this.$message.error('获取失败请联系开发人员')
                }
                this.tableData = res.Data.List
                this.total = res.Data.TotalRows
            },
            // 获取父级列表
            async GetParentList(){
                let data = {}
                data.Level = 1
                data.IsEffective = 1
                data.UserType = 1
                let res = await ListCertificateType(data)
                this.ParentList = res.Data.List
            },
            // 点击新增/编辑
            clickAddAndEditShow(is,row){
                this.editorShow = true
                this.GetParentList()
                console.log(row)
                if(is ==1) {
                    this.title = '新增'
                    this.CertificateTypeName =''
                    this.IsFirstLevel = true
                    this.ParentId = ''
                }else {
                    this.title = '编辑'
                    this.$nextTick(()=> {
                        this.CertificateTypeName = row.CertificateTypeName
                        this.IsFirstLevel = row.IsFirstLevel
                        this.ParentId = row.ParentId || ''
                        this.Id = row.Id
                    })
                }
                
            },
            // 新增证书
            certuficatFun(){
                this.submitAllLoading = true
                let data = {}
                data.CertificateTypeName = this.CertificateTypeName
                data.IsFirstLevel = this.IsFirstLevel
                data.ParentId = this.ParentId
                data.UserType = 1
                data.Id = this.Id
                if(!data.CertificateTypeName) {
                    return this.$message.warning('证书名称不能为空！')
                }
                if(!data.IsFirstLevel && !data.ParentId) {
                    return this.$message.warning('请选择父级')
                }
                !data.ParentId && delete data.ParentId
                if(this.title=='新增') {
                    delete data.Id
                    AddCertificateType(data).then(res=> {
                        this.submitAllLoading = false
                        if(res.Result != 1) {
                            return this.$message.error(res.Message)
                        }
                        this.$message.success(res.Message)
                        this.GetCertificateTypeList();
                        this.editorShow = false
                    })
                }else {
                    UpdateCertificateType(data).then(res=> {
                        this.submitAllLoading = false
                        if(res.Result != 1) {
                            return this.$message.error(res.Message)
                        }
                        this.$message.success(res.Message)
                        this.GetCertificateTypeList();
                        this.editorShow = false
                    })
                }
            },
            // 修改证书状态
            UpdateCertificateTypeStatusFun(row){
                let data = {}
                data.Id = row.Id
                data.Status = row.IsDelete
                UpdateCertificateTypeStatus(data).then(res=> {
                    if(res.Result != 1){
                        return this.$message.error(res.Message)
                    }
                    this.$message.success(res.Message)
                    this.GetCertificateTypeList();
                })
            },
            //上移下移
            upDownMove: function (id, move) {
                var data = {
                    Id: id,
                    Difference: move,
                }
                UpdateCertificateTypeSortNo(data).then(res => {
                    if(res.Result != 1) {
                        return this.$message.error(res.Message)
                    }
                    this.$message.success('操作成功！')
                    this.GetCertificateTypeList()
                })
            },
        }
    }
</script>